export { LexiconModule } from './lexicon.module';
export { LexiconLoader } from './lexicon.loader';
export { LexiconMissingTranslationHandler } from './lexicon.missing-translation-handler';
export { LexiconApiService } from '@vendasta/lexicon';
export * from './constants';
export { TranslateService, DEFAULT_LANGUAGE } from '@ngx-translate/core';
